module.exports = __webpack_public_path__ + "media/yqvideo.e777e65f.mp4";